module.exports = __webpack_public_path__ + "img/Bitmap@c12x.7582e06a.png";